import { ASSIGN_COACH, ASSIGN_COACH_EMPTY, ASSIGN_COACH_ERROR, ASSIGN_COACH_SUCCESS } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AssignCoach = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_COACH:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_COACH_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_COACH_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ASSIGN_COACH_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AssignCoach;
